/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

@cc._decorator.ccclass
export default class DebugNode
{
    private _active: boolean = true;

    public get active(): boolean
    {
        return this._active;
    }

    public set active(value: boolean)
    {
        this._active = value;
    }

    public Bind(node: cc.Node): void
    {
        Object.defineProperty(node, 'active', {
            get: () => this.active,
            set: (value: boolean) => this.active = value
        });
    }
}
